{
  "clubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
  "players": [
    {
      "id": "3ab26eed-28c0-41df-9e64-cb11cedaddd8",
      "playerDefinitionId": "15524027-c455-57e6-b90a-0781819e1570",
      "displayName": "José María Giménez",
      "age": 31,
      "realClub": {
        "id": "5b2211d5-8f8c-5670-98d8-3c6090290dea",
        "name": "RC Deportivo A Coruña",
        "shortName": "DEP"
      },
      "position": "DEFENDER",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 12000000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 6.45,
      "last3AveragePoints": 6.80,
      "rating": 6.45,
      "ratedAppearances": 6,
      "unavailabilities": []
    },
    {
      "id": "aa42199e-c83d-46db-9d3e-4c96c8565046",
      "playerDefinitionId": "4bdfe31e-e5d9-55d6-bf5f-b23685c0e509",
      "displayName": "Johnny Cardoso",
      "age": 25,
      "realClub": {
        "id": "a7475825-551e-5536-bf19-460a7035048f",
        "name": "Atlético de Madrid",
        "shortName": "ATM"
      },
      "position": "MIDFIELDER",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 18000000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 6.20,
      "last3AveragePoints": 5.90,
      "rating": 6.20,
      "ratedAppearances": 5,
      "unavailabilities": [
        {
          "type": "INJURY",
          "reason": "Intestinal virus",
          "startDate": "2026-10-16",
          "expectedEndDate": "2026-10-19",
          "status": "ACTIVE"
        }
      ]
    },
    {
      "id": "00cd2537-7384-47c0-9124-2ac00edc3619",
      "playerDefinitionId": "5fc0934e-02a7-5ce1-8a6d-a6f9913b968a",
      "displayName": "Kang-in Lee",
      "age": 25,
      "realClub": {
        "id": "a7475825-551e-5536-bf19-460a7035048f",
        "name": "Atlético de Madrid",
        "shortName": "ATM"
      },
      "position": "MIDFIELDER",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 25000000.00,
      "version": 1,
      "secondaryPositions": [
        "FORWARD"
      ],
      "ratingSeasonId": null,
      "averagePoints": 7.15,
      "last3AveragePoints": 7.40,
      "rating": 7.15,
      "ratedAppearances": 7,
      "unavailabilities": []
    },
    {
      "id": "06526260-bb0d-4c53-85fd-63f6cbbe2ec2",
      "playerDefinitionId": "47415516-4953-5a6a-8851-dc22e554e150",
      "displayName": "Antonio Sivera",
      "age": 30,
      "realClub": {
        "id": "69643b14-a20e-5d7a-a578-9f8f0bef9843",
        "name": "Deportivo Alavés",
        "shortName": "ALA"
      },
      "position": "GOALKEEPER",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 6500000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 6.82,
      "last3AveragePoints": 7.10,
      "rating": 6.82,
      "ratedAppearances": 7,
      "unavailabilities": []
    },
    {
      "id": "93c5e7c1-4fd3-4bfe-b924-4f5bf2a232a3",
      "playerDefinitionId": "daae4b97-96e4-5a7d-8397-f10911e8bf2b",
      "displayName": "Lamine Yamal",
      "age": 19,
      "realClub": {
        "id": "e82a5fde-22b1-5036-8763-5cdb76d60fab",
        "name": "FC Barcelona",
        "shortName": "BAR"
      },
      "position": "FORWARD",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 120000000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 8.75,
      "last3AveragePoints": 9.20,
      "rating": 8.75,
      "ratedAppearances": 7,
      "unavailabilities": []
    },
    {
      "id": "3be21f33-1b02-4530-8d73-9431128a99d5",
      "playerDefinitionId": "3467bf76-4323-5e23-bbe2-e70c3e2a59f5",
      "displayName": "Marcos Alonso",
      "age": 35,
      "realClub": {
        "id": "05c4b638-2dae-5dcc-ab96-3620ba4b2e27",
        "name": "RC Celta de Vigo",
        "shortName": "CEL"
      },
      "position": "DEFENDER",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 3500000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 5.80,
      "last3AveragePoints": 6.10,
      "rating": 5.80,
      "ratedAppearances": 6,
      "unavailabilities": []
    },
    {
      "id": "639f5c8e-c4fb-4052-9731-5d583579edef",
      "playerDefinitionId": "e86eb34b-e58c-502d-a4e2-26701e285152",
      "displayName": "Cucho Hernández",
      "age": 27,
      "realClub": {
        "id": "2ecf78f4-13e1-5b6f-a8cf-d54cb0a5f65d",
        "name": "Real Betis Balompié",
        "shortName": "BET"
      },
      "position": "FORWARD",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 15000000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 6.95,
      "last3AveragePoints": 7.30,
      "rating": 6.95,
      "ratedAppearances": 7,
      "unavailabilities": []
    },
    {
      "id": "6774caaf-918c-47ec-9ecb-902434156733",
      "playerDefinitionId": "778c494b-2ec4-5c50-a3bd-ba248524e251",
      "displayName": "Randy Nteka",
      "age": 28,
      "realClub": {
        "id": "bd3ebb2d-2755-5be9-870f-90af12d25b6a",
        "name": "Rayo Vallecano",
        "shortName": "RAY"
      },
      "position": "MIDFIELDER",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 4500000.00,
      "version": 1,
      "secondaryPositions": [
        "FORWARD"
      ],
      "ratingSeasonId": null,
      "averagePoints": 5.90,
      "last3AveragePoints": 5.60,
      "rating": 5.90,
      "ratedAppearances": 5,
      "unavailabilities": []
    },
    {
      "id": "6ff3e096-933f-4d7d-8d00-b53bef56c627",
      "playerDefinitionId": "63e5a580-fdbb-5b94-a1b6-d82140cd22b3",
      "displayName": "Dean Huijsen",
      "age": 21,
      "realClub": {
        "id": "fa3fc031-5b80-5f15-94f1-d416ca4ab172",
        "name": "Real Madrid CF",
        "shortName": "MAD"
      },
      "position": "DEFENDER",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 22000000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 6.70,
      "last3AveragePoints": 7.00,
      "rating": 6.70,
      "ratedAppearances": 6,
      "unavailabilities": []
    },
    {
      "id": "0417a33b-98fa-44f4-858b-85c4074e0a0f",
      "playerDefinitionId": "7506e65b-6456-566b-94d4-78621b9db6a8",
      "displayName": "Yan Diomande",
      "age": 19,
      "realClub": {
        "id": "fa3fc031-5b80-5f15-94f1-d416ca4ab172",
        "name": "Real Madrid CF",
        "shortName": "MAD"
      },
      "position": "FORWARD",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 8000000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 6.10,
      "last3AveragePoints": 6.40,
      "rating": 6.10,
      "ratedAppearances": 4,
      "unavailabilities": []
    },
    {
      "id": "feb5c184-9500-4cc8-9663-71bcb30b3314",
      "playerDefinitionId": "16167299-c6af-5999-982c-cd199d840c54",
      "displayName": "Gonçalo Guedes",
      "age": 29,
      "realClub": {
        "id": "5507b3c5-9f27-57a8-90e1-dde42ac1bdb4",
        "name": "Real Sociedad",
        "shortName": "RSO"
      },
      "position": "FORWARD",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 14000000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 6.60,
      "last3AveragePoints": 6.30,
      "rating": 6.60,
      "ratedAppearances": 6,
      "unavailabilities": []
    },
    {
      "id": "263ee12f-3935-4092-bba7-8d7c3600f32c",
      "playerDefinitionId": "b1a14bc4-6411-56c4-b49d-bd448b7a36de",
      "displayName": "Jude Bellingham",
      "age": 23,
      "realClub": {
        "id": "fa3fc031-5b80-5f15-94f1-d416ca4ab172",
        "name": "Real Madrid CF",
        "shortName": "MAD"
      },
      "position": "MIDFIELDER",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 140000000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 8.90,
      "last3AveragePoints": 9.10,
      "rating": 8.90,
      "ratedAppearances": 7,
      "unavailabilities": []
    },
    {
      "id": "3c0493bf-c27e-4d4f-982a-8dfd95b24e70",
      "playerDefinitionId": "ec2b5909-e3bb-5e70-a134-fb13104dffd6",
      "displayName": "Álex Baena",
      "age": 25,
      "realClub": {
        "id": "a7475825-551e-5536-bf19-460a7035048f",
        "name": "Atlético de Madrid",
        "shortName": "ATM"
      },
      "position": "FORWARD",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 40000000.00,
      "version": 1,
      "secondaryPositions": [
        "MIDFIELDER"
      ],
      "ratingSeasonId": null,
      "averagePoints": 7.45,
      "last3AveragePoints": 7.80,
      "rating": 7.45,
      "ratedAppearances": 7,
      "unavailabilities": []
    },
    {
      "id": "8ba9e687-82fb-44aa-96e4-62d7f9585219",
      "playerDefinitionId": "e67969e8-992e-5624-8576-11b15435cf3d",
      "displayName": "Angeliño",
      "age": 29,
      "realClub": {
        "id": "5b2211d5-8f8c-5670-98d8-3c6090290dea",
        "name": "RC Deportivo A Coruña",
        "shortName": "DEP"
      },
      "position": "DEFENDER",
      "type": "REAL",
      "competitionUnitId": "28280587-d4cc-8599-bbaf-8a50e026a7b1",
      "ownerClubId": "1b296210-fd7d-5202-a17f-657bd97aec7b",
      "status": "CONTRACTED",
      "currentMarketValue": 9000000.00,
      "version": 1,
      "secondaryPositions": [],
      "ratingSeasonId": null,
      "averagePoints": 6.30,
      "last3AveragePoints": 6.50,
      "rating": 6.30,
      "ratedAppearances": 6,
      "unavailabilities": []
    }
  ],
  "coach": {
    "id": "f02797e8-c9d2-4060-ab65-ef9171cd4a34",
    "name": "Diego Simeone",
    "imageUrl": null,
    "age": 56,
    "realClub": {
      "id": "a7475825-551e-5536-bf19-460a7035048f",
      "name": "Atlético de Madrid",
      "shortName": "ATM"
    },
    "attack": 4.00,
    "midfield": 2.00,
    "defense": 9.00
  }
}
